import { Directive, Input, TemplateRef } from '@angular/core';
import { PhxRadioTileType } from './phx-radio-list.types';

@Directive({
  selector: '[phx-radio-button]',
})
export class PhxRadioButtonDirective {}

@Directive({
  selector: '[phx-radio]',
})
export class PhxRadioDirective {}

@Directive({
  selector: '[phx-radio-tile]',
})
export class PhxRadioTileDirective {
  @Input() phxIcon: string;
  @Input() phxType: PhxRadioTileType = 'default';
  @Input() phxPrefixTemplate: TemplateRef<any>;
  @Input() phxSuffixTemplate: TemplateRef<any>;
}
